import React from 'react'
import './Footer.css';
import './Media-styles.css';
import Lin from './img/in.webp';
import Mail from './img/mail.webp';
import Phone from './img/phone.webp';
import Ft_Logo from './img/Logo/ft-logo.webp';



function Footer() {
  return (
    <div className='ft-main-container'>
    <div className='footer-container'>
      <div className='footer-col1'><a href="/"><img src={Ft_Logo} alt="Acoustics" /></a><div className="ft-info">Since 1978, Acoustics has been dedicated to delivering exceptional quality products and services.</div></div>
      <div className='footer-col2'><h3 className="ft-col-tit">Find more</h3><ul>
      <li className='ft-col-list range-mob'><a href='/'>Home</a></li>
        <li className='ft-col-list range-desk'><a href='/Paneline/'>Paneline</a></li>
        <li className='ft-col-list range-desk'><a href='/ProRange/'>Portfolio</a></li>
        <li className='ft-col-list range-desk'><a href='/Contact-us/'>Contact us</a></li>
        
      </ul></div>



      <div className='footer-col3'><h3 className="ft-col-tit">Downloads</h3><ul>
        <li className='ft-col-list'><a href="https://www.acoustic.com.au/downloads/Acoustics-Product-Brochure.pdf" target="_blank" rel="noreferrer">Brochures</a></li>
                                             

        <li className='ft-col-list privacy'><a href="http://acoustic.com.au/downloads/Acoustics-Installation-Guide.pdf" target="_blank" rel="noreferrer">Installation Guide</a></li>
        <li className='ft-col-list privacy'><a href="http://acoustic.com.au/downloads/Acoustics-Data-Sheet.pdf" target="_blank" rel="noreferrer">Data Sheet</a></li>
        <li className='ft-col-list privacy'><a href="http://acoustic.com.au/downloads/Tests/Acoustics-Test-Certificate.pdf" target="_blank" rel="noreferrer">Acoustic Testing</a></li>
        <li className='ft-col-list privacy'><a href="http://acoustic.com.au/downloads/Tests/Acoustics-Fire-Test-Certificate.pdf"  target="_blank" rel="noreferrer">Fire Certificate</a></li>
        <li className='ft-col-list privacy'><a href="http://acoustic.com.au/downloads/Warranty/Acoustics-Warranty-Policy.pdf" target="_blank" rel="noreferrer">Warranty</a></li>
        
      </ul></div>
      <div className='footer-col4'><h3 className="ft-col-tit">Contact us</h3>
        <ul>
          
          <li className='social'><a href="https://www.linkedin.com/company/104802238" target='_blank' rel="noreferrer"><img src={Lin} alt="Acoustic" /></a></li>
          <li className='social'><a href="mailto:enquiries@acoustic.com.au"><img src={Mail} alt="Acoustic" /></a></li>
          <li className='social'><a href="tel:08 6156 0444"><img src={Phone} alt="Acoustic" /></a></li>
        </ul>
        <div className="ft-info ft-adrs">107 Mulgul Road, Malaga, WA, 6090
        
        </div>

        <div className='ft-info-bright ft-adrs'>Website by : <a href="mailto:rpdeveloper06@gmail.com" target='_blank'  rel="noreferrer"><em className='emph'> -</em>RP</a></div>
        
    </div>
    </div>
    </div>
  )
}

export default Footer;